import Link from 'next/link'

const members = [
    {
        name: 'Hammton Ndeke',
        role: 'Founder',
        avatar: '/images/founder.jpg',
        link: 'https://www.linkedin.com/in/hammton-ndeke/',
    },
]

export default function TeamSection() {
    return (
        <section className="bg-gradient-to-br from-gray-50 to-white py-24 dark:from-gray-900 dark:to-black">
            <div className="mx-auto max-w-7xl px-6">
                <div className="text-center mb-16">
                    <div className="inline-block mb-4 px-4 py-2 bg-purple-100 rounded-full">
                        <span className="text-purple-700 text-sm font-semibold">OUR TEAM</span>
                    </div>
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
                        Meet the Team
                    </h2>
                    <p className="text-xl text-gray-900 dark:text-gray-100 max-w-3xl mx-auto font-semibold">
                        Passionate about helping professionals master high-stakes moments
                    </p>
                </div>

                <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                    {members.map((member, index) => (
                        <div
                            key={index}
                            className="group relative overflow-hidden rounded-3xl bg-white shadow-lg hover:shadow-2xl transition-all duration-500"
                        >
                            <div className="relative overflow-hidden">
                                <img
                                    className="h-96 w-full object-cover object-top grayscale transition-all duration-500 group-hover:grayscale-0 group-hover:scale-110"
                                    src={member.avatar}
                                    alt={member.name}
                                    width="826"
                                    height="1239"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>

                            <div className="p-6">
                                <div className="flex justify-between items-start mb-2">
                                    <h3 className="text-xl font-bold text-gray-900 transition-all duration-500 group-hover:text-purple-600">
                                        {member.name}
                                    </h3>
                                    <span className="text-xs text-gray-400 font-mono">_0{index + 1}</span>
                                </div>

                                <div className="flex items-center justify-between">
                                    <span className="text-gray-600 text-sm font-medium inline-block translate-y-2 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                                        {member.role}
                                    </span>
                                    <Link
                                        href={member.link}
                                        className="text-purple-600 dark:text-purple-400 inline-block translate-y-4 text-sm font-semibold opacity-0 transition-all duration-500 hover:underline group-hover:translate-y-0 group-hover:opacity-100"
                                    >
                                        Connect →
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
